import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { AuthenticatedUser } from 'libs/authentication/src/lib/+state/authentication.interfaces';
import { take } from 'rxjs/operators';
import { TemplatesFacade } from '../../../../xsr-template-library/src/lib/+state/templates.facade';
@Component({
  selector: 'quorum-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  authenticatedUser: AuthenticatedUser;
  selectedLanguage: string;
  constructor(
    private authenticationStateService: AuthenticationStateService,
    private snackBar: MatSnackBar,
    public templateFacade: TemplatesFacade
  ) {}

  ngOnInit(): void {
    this.authenticationStateService
      .selectAuthenticatedUser()
      .pipe(take(1))
      .subscribe((user) => (this.authenticatedUser = user));

    this.templateFacade.snackBarSubject$.subscribe((snackBarOptions) =>
      this.snackBar.open(snackBarOptions.message, snackBarOptions.action, snackBarOptions.config)
    );
  }

  setLanguage(language: string) {
    this.templateFacade.selectLanguage(language);
  }

  logout() {
    this.authenticationStateService.logout();
  }
}
